import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Pobegla cerkev",
  "description": "",
  "published": "2007-02-13T00:00:00.000Z",
  "redirect_from": ["/blog/pobegla-cerkev/swizec/288"],
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Opa, ze lep cas nisem nic spregovoril na tem koscku spletnega neba, verjetno je zatajil spomin ali kaj podobnega. No kakorkoli, tu je filmcek cerkve, ki bezi od sosedov, uboga rec.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      